import { Switch, message } from 'antd';
import { FC, useState } from 'react';
import { errorObjectToString } from 'src/utils/common';
import { AuditLogger } from 'src/utils/audit-logger';

const auditLogger = AuditLogger.getInstance();

interface AgCellToggleEditorProps {
  id: string;
  value: boolean;
  field: string;
  onChange: (id: string, data: Record<string, any>) => Promise<any>;
  disabled?: boolean;
  size?: 'small' | 'default';
}

const AgCellToggleEditor: FC<AgCellToggleEditorProps> = ({
  id,
  value,
  field,
  onChange,
  size = 'default',
  disabled,
}) => {
  const [loading, setLoading] = useState(false);

  const handleSwitchChange = async (value: boolean, id: string, field: string) => {
    setLoading(true);
    try {
      await onChange(id, {
        [field]: value,
      });
      message.success('변경완료.');
    } catch (error: any) {
      const errorMessage = errorObjectToString(error);
      message.error(errorMessage);
      auditLogger.log({
        action: 'UPDATE',
        entity: 'product',
        entityId: id,
        summary: `AgCellToggleEditor - [${field}: ${value}]\n${errorMessage}`,
        level: 'error',
      });
    }
    setLoading(false);
  };

  return (
    <Switch
      loading={loading}
      checked={value}
      onChange={(v) => handleSwitchChange(v, id, field)}
      size={size}
      disabled={disabled}
    />
  );
};

export default AgCellToggleEditor;
